export default function Problems() {
  const problems = [
    {
      icon: 'ri-question-line',
      title: '業者選びが不安',
      description: 'リフォーム業者はどこも同じに見えて、どこを選べばいいのか分からない...'
    },
    {
      icon: 'ri-home-4-line',
      title: '家が汚れないか心配',
      description: '工事中に家が汚れたり、傷つけられたりしないか不安で仕方ない...'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '契約後の対応が不安',
      description: '契約したら態度が変わったり、アフターフォローがないのでは...'
    }
  ];

  return (
    <section id="problems" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Problems */}
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-12">
            こんな<span className="text-3xl sm:text-4xl lg:text-5xl">お悩み</span><br className="sm:hidden" />ありませんか?
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {problems.map((problem, index) => (
              <div key={index} className="bg-[#faf8f5] rounded-2xl p-8 hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center mb-6">
                  <i className={`${problem.icon} text-5xl text-[#1a2b4a]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2b4a] mb-4">{problem.title}</h3>
                <p className="text-gray-600 leading-relaxed">{problem.description}</p>
              </div>
            ))}
          </div>

          {/* Arrow */}
          <div className="flex justify-center mb-12">
            <div className="w-16 h-16 flex items-center justify-center bg-[#ff8c42] rounded-full">
              <i className="ri-arrow-down-line text-3xl text-white"></i>
            </div>
          </div>

          {/* Solution */}
          <div className="relative max-w-4xl mx-auto">
            <div className="absolute -top-8 -right-8 w-64 h-64 bg-[#ff8c42]/10 rounded-full blur-3xl"></div>
            <div className="relative bg-gradient-to-br from-[#faf8f5] to-white rounded-3xl p-8 sm:p-12 shadow-xl">
              <p className="text-base sm:text-xl text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                私たちは、技術と価格だけでなく<br />
                <span className="text-2xl sm:text-4xl lg:text-5xl font-bold text-[#1a2b4a] block mt-2 mb-2">『ホスピタリティ』を</span>
                <span className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#ff8c42] block">公約として掲げています</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
